import { PeopleBuyingTeam } from '@aibees/elephant/components/people-buying-team';
import { PeopleUnlock } from '@aibees/elephant/components/people-unlock';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useSearchPersonStore } from '@aibees/elephant/feature/search-table-people/store';
import { IconButton } from '@aibees/shared/components';
import { useTableSearchItemStore } from '@aibees/shared/store/table-search-item';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import { Navigation, type HeaderNavigationProps as Props } from './types';
import { usePeopleDrawerHeaderNavigationButtonsState } from './use-people-drawer-header-navigation-buttons-state';
import { ViewFullProfile } from '@aibees/elephant/components/view-full-profile';
import { usePeopleDrawerHeaderNavigationFullProfileLink } from './use-people-drawer-header-navigation-full-profile-link';

export const HeaderNavigation = memo(({ className, drawerState }: Props) => {
  const { peopleSearchItems, setId, id } = useSearchPersonStore();
  const tableIds = peopleSearchItems.map((item) => item.id);
  const { setSelectedItem } = useTableSearchItemStore();
  const { api } = usePersonReadDataContext();
  const [prevDisabled, nextDisabled] =
    usePeopleDrawerHeaderNavigationButtonsState();
  const fullProfileLink = usePeopleDrawerHeaderNavigationFullProfileLink();
  const handleNavigation = (value: Navigation) => {
    if (id) {
      const current = tableIds.indexOf(id);
      setId(tableIds[current + value]);
      setSelectedItem(tableIds[current + value]);
    }
  };

  return (
    <Styled.Wrapper
      className={classnames('HeaderNavigation', className)}
      direction="row"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        {api?.data && <PeopleUnlock item={api?.data} />}
        {api?.data && <ViewFullProfile link={fullProfileLink} size="small" />}
        {api?.data && <PeopleBuyingTeam personId={api?.data?.id} isSideBar />}
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <IconButton
            onClick={() => handleNavigation(Navigation.PREV)}
            disabled={prevDisabled}
            variant="outlined"
            icon={'chevron-up'}
            size="xsmall"
            iconColor="default"
            iconSize={16}
          />
          <IconButton
            onClick={() => handleNavigation(Navigation.NEXT)}
            disabled={nextDisabled}
            variant="outlined"
            icon={'chevron-down'}
            iconColor="default"
            size="xsmall"
            iconSize={16}
          />
        </Stack>
        <IconButton
          onClick={drawerState?.onFalse}
          icon="close"
          color="default"
          size="xsmall"
          iconSize={16}
        />
      </Stack>
    </Styled.Wrapper>
  );
});

HeaderNavigation.displayName = 'HeaderNavigation';
